import { formatDistance } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function timeAgo(timestamp: string): string {
  const date = new Date(timestamp);
  const now = new Date();
  
  return formatDistance(date, now, { locale: ptBR });
}